module.exports = __webpack_public_path__ + "static/media/findmotors_logo.b645ea81.svg";